import { Money } from '@chukua/common';

/** "KES 12,500.50" — a receipt is a cash amount checked against a bank statement, so cents always show (the shared formatMoney drops a trailing zero: "12,500.5"). */
export function formatReceiptAmount(amount: { amountMinor: number; currency: string }): string {
  const [whole = '0', cents = '00'] = Money.fromJSON(amount as Parameters<typeof Money.fromJSON>[0])
    .toDecimalString()
    .split('.');
  return `${amount.currency} ${new Intl.NumberFormat('en-KE').format(Number(whole))}.${cents}`;
}
